import { showToast } from '@shared/atoms';
import { useEffect, useState } from 'react';
import useQuery from './useQuery';

declare global {
  interface Window {
    natively?: any;
  }
}

export default function useIsMobileApp() {
  const searchParams = useQuery();
  const checkIsMobileParam = searchParams.get('isMobileApp') === 'true';
  const [isMobileApp, setIsMobileApp] = useState(checkIsMobileParam);

  useEffect(() => {
    const { natively } = window;

    if (
      navigator.userAgent.indexOf('gonative') > -1 ||
      natively.isAndroidApp ||
      natively.isIOSApp
    ) {
      setIsMobileApp(true);
    }
  }, []);

  return isMobileApp;
}
